/* BLED PETITE MAROCAINE v4. Vanilla JS, IntersectionObserver, transform/opacity uniquement.
   Sans JS ou prefers-reduced-motion : pas d'animation, tout reste visible (moments en cartes). */
(function(){
  var root=document.querySelector('[data-pmh]');if(!root)return;
  /* Guide des tailles : cm / pouces (fonctionne aussi sans animation) */
  var sz=root.querySelector('[data-pmh-size]');
  if(sz)sz.addEventListener('click',function(e){var b=e.target.closest('[data-pmh-unit]');if(!b)return;var u=b.getAttribute('data-pmh-unit');
    [].forEach.call(sz.querySelectorAll('[data-pmh-unit]'),function(x){var on=x===b;x.classList.toggle('is-on',on);x.setAttribute('aria-pressed',on?'true':'false')});
    [].forEach.call(sz.querySelectorAll('[data-cm]'),function(x){x.hidden=u!=='cm'});[].forEach.call(sz.querySelectorAll('[data-in]'),function(x){x.hidden=u!=='in'})});
  /* Option à valeur unique (ex. Couleur : Blanc) : on la retire du sélecteur du thème et on l'affiche en clair */
  [].forEach.call(document.querySelectorAll('#MainContent .product-single__meta .variant-wrapper'),function(w){var ins=w.querySelectorAll('.variant-input');if(ins.length!==1)return;
    var lab=w.querySelector('.variant__label'),val=(ins[0].querySelector('input')||{}).value;if(!val)return;w.style.display='none';
    var nx=w.nextElementSibling;var l2=nx&&nx.querySelector('.variant__label');if(l2&&!l2.querySelector('.pmh-one')){var sp=document.createElement('span');sp.className='pmh-one';sp.textContent='\u00a0· '+val;sp.style.cssText='text-transform:none;font-weight:600;opacity:.75;margin-left:.3em';(l2.firstChild&&l2.firstChild.nodeType===3?l2.insertBefore(sp,l2.firstChild.nextSibling):l2.appendChild(sp))}});
  /* Sauts vers le formulaire d'achat */
  root.addEventListener('click',function(e){var a=e.target.closest('[data-pmh-jump]');if(!a)return;var t=document.getElementById('pmh-acheter');if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth'})}});

  var rm=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(rm||!('IntersectionObserver' in window)||!window.requestAnimationFrame)return;
  root.classList.add('pmh-js');

  /* ---------- Compteurs + apparitions ---------- */
  function count(el){var to=parseFloat(el.getAttribute('data-pmh-count'))||0,from=parseFloat(el.getAttribute('data-from')||0),t0=null,d=1500;
    function f(t){if(!t0)t0=t;var p=Math.min(1,(t-t0)/d),e=1-Math.pow(1-p,4);el.textContent=String(Math.round(from+(to-from)*e));if(p<1)requestAnimationFrame(f)}
    el.textContent=String(from);requestAnimationFrame(f)}
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(!e.isIntersecting)return;var n=e.target;n.classList.add('is-in');
    var c=n.querySelectorAll('[data-pmh-count]');for(var i=0;i<c.length;i++)count(c[i]);io.unobserve(n)})},{rootMargin:'0px 0px -10% 0px',threshold:.05});
  root.querySelectorAll('[data-pmh-rv],.pmh-open,.pmh-gift,.pmh-sc2,.pmh-buy__art').forEach(function(n){io.observe(n)});

  function cl(v){return v<0?0:v>1?1:v}
  function seg(p,a,b){return cl((p-a)/(b-a))}
  function io3(t){return t<.5?4*t*t*t:1-Math.pow(-2*t+2,3)/2}
  function oe(t){return 1-Math.pow(1-t,3)}
  var vw=innerWidth,vh=innerHeight;

  /* ---------- Spectacle épinglé ---------- */
  var show=root.querySelector('[data-pmh-show]');
  var N=show?+show.getAttribute('data-n')||9:9;if(show)show.style.setProperty('--n',N);
  var stage=root.querySelector('[data-pmh-stage]'),tee=root.querySelector('[data-pmh-tee]'),slog=root.querySelector('[data-pmh-slog]'),halo=root.querySelector('[data-pmh-halo]');
  var chs=[].slice.call(root.querySelectorAll('[data-pmh-ch]')),scs=[].slice.call(root.querySelectorAll('[data-pmh-sc]')),gws=[].slice.call(root.querySelectorAll('[data-pmh-g]'));
  var caps=[].slice.call(root.querySelectorAll('[data-pmh-cap]')),dots=[].slice.call(root.querySelectorAll('[data-pmh-dot]'));
  var dotsW=root.querySelector('.pmh-dots'),showH=root.querySelector('.pmh-show__h');
  var I=.2,capI=0,scI=0,gI=-1,dI=-1,W=1,showOn=false;
  /* pose du t-shirt pour chaque moment : rotation (deg), x/y (fraction de la scène), échelle */
  var POSE=[[-6,-.04,.02,.92],[5,.05,0,.95],[-9,0,-.05,1.02],[8,.06,.03,.9],[-4,-.05,0,.94],[3,0,.02,.96],[-2,0,0,.9],[10,.04,-.02,.98],[0,0,0,1]];
  var vec=chs.map(function(c,i){var a=i*2.39996+.5,r=.6+((i*7)%5)/7;return{x:Math.cos(a)*r,y:Math.sin(a)*r,rot:((i*53)%160)-80,s:.6+((i*3)%4)/3}});
  function measure(){vw=innerWidth;vh=innerHeight;W=stage?stage.offsetWidth:1;if(stage)stage.style.setProperty('--sw',W+'px')}
  function setOn(list,i,cur){if(i===cur)return cur;if(list[cur])list[cur].classList.remove('is-on');if(list[i])list[i].classList.add('is-on');return i}
  function renderShow(){
    var r=show.getBoundingClientRect(),len=r.height-vh;if(len<=0)return;
    var p=cl(-r.top/len);
    var tx=0,ty=0,rot=0,s=1,sx=1,op=1,hs=1,hr=p*240;
    if(p<I){
      var a=oe(seg(p,0,.035)),z=io3(seg(p,.035,.085)),lift=seg(p,.09,.12),ex=io3(seg(p,.12,.175)),back=io3(seg(p,.13,.2));
      var zz=1+1.35*z*(1-back);
      s=(.8+.2*a)*zz*(1-(1-POSE[0][3])*back);rot=-8*(1-a)+POSE[0][0]*back;
      ty=.08*W*zz*z*(1-back)+POSE[0][2]*W*back;tx=POSE[0][1]*W*back;
      op=1-.8*lift*(1-back);
      var so=seg(p,.07,.095)*(1-seg(p,.165,.195));
      slog.style.opacity=so.toFixed(3);
      slog.style.transform='translateY(-50%) translateY('+(-lift*.06*W).toFixed(1)+'px) scale('+(1+.06*lift+.2*ex).toFixed(3)+')';
      var D=Math.max(vw,vh)*.95;
      for(var i=0;i<chs.length;i++){var v=vec[i];chs[i].style.transform=ex>0?'translate3d('+(v.x*D*ex).toFixed(1)+'px,'+(v.y*D*ex).toFixed(1)+'px,0) rotate('+(v.rot*ex*2).toFixed(1)+'deg) scale('+(1+(v.s-1)*ex).toFixed(3)+')':''}
      hs=1+.25*z*(1-back);
    }else{
      slog.style.opacity='0';
      var q=(p-I)/(1-I)*N,m=Math.min(N-1,Math.floor(q)),f=m===N-1&&q>=N?1:q-m;
      var A=POSE[Math.max(0,m-1)%POSE.length],B=POSE[m%POSE.length],t=m===0?1:io3(seg(f,0,.24));
      rot=A[0]+(B[0]-A[0])*t;tx=(A[1]+(B[1]-A[1])*t)*W;ty=(A[2]+(B[2]-A[2])*t)*W;s=A[3]+(B[3]-A[3])*t;
      if(m>0&&t>0&&t<1){sx=Math.max(.05,Math.abs(Math.cos(t*Math.PI)));ty-=Math.sin(t*Math.PI)*W*.12}
      rot+=Math.sin(f*Math.PI*2)*1.6;hs=1+.08*Math.sin(f*Math.PI);
      /* mot géant */
      if(m!==gI){var prev=gws[gI];if(prev){prev.classList.remove('is-on');prev.classList.add('is-out');(function(el){setTimeout(function(){if(!el.classList.contains('is-on'))el.classList.remove('is-out')},700)})(prev)}
        if(gws[m]){gws[m].classList.remove('is-out');gws[m].classList.add('is-on')}gI=m}
      dI=setOn(dots,m,dI);
    }
    if(p<I&&gI!==-1){var g=gws[gI];if(g){g.classList.remove('is-on');g.classList.add('is-out');setTimeout(function(){g.classList.remove('is-out')},700)}gI=-1;}
    if(p<I&&dI!==-1){dots[dI].classList.remove('is-on');dI=-1}
    if(dotsW)dotsW.classList.toggle('is-off',p<I);
    if(showH)showH.classList.toggle('is-off',p>=.07);
    tee.style.transform='translate3d('+tx.toFixed(1)+'px,'+ty.toFixed(1)+'px,0) rotate('+rot.toFixed(2)+'deg) scale('+(s*sx).toFixed(4)+','+s.toFixed(4)+')';
    tee.style.opacity=op.toFixed(3);
    if(halo)halo.style.transform='translate3d('+(tx*.5).toFixed(1)+'px,'+(ty*.5).toFixed(1)+'px,0) rotate('+hr.toFixed(1)+'deg) scale('+hs.toFixed(3)+')';
    var sI=p<I?0:1+Math.min(N-1,Math.floor((p-I)/(1-I)*N));scI=setOn(scs,sI,scI);
    var c=p<.085?0:p<I?1:sI+1;capI=setOn(caps,c,capI);
  }

  /* ---------- Barre collante (bureau) ---------- */
  var bar=root.querySelector('[data-pmh-bar]');
  function renderBar(){if(!bar||vw<769)return;var rr=root.getBoundingClientRect();bar.classList.toggle('is-on',rr.top<vh*.35&&rr.bottom>vh)}

  var tk=false;
  function frame(){tk=false;if(showOn&&show)renderShow();renderBar()}
  function req(){if(!tk){tk=true;requestAnimationFrame(frame)}}
  var vio=new IntersectionObserver(function(es){es.forEach(function(e){if(e.target===show)showOn=e.isIntersecting});req()},{rootMargin:'200px 0px'});
  if(show)vio.observe(show);
  measure();
  addEventListener('scroll',req,{passive:true});
  var rt;addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(function(){measure();req()},120)});
  addEventListener('load',function(){measure();req()});
  req();
})();
